import arrayLikeToArray from "./arrayLikeToArray.js";
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return arrayLikeToArray(r);
}
export { _arrayWithoutHoles as default };


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/arrayWithoutHoles.js
// module id = 1078
// module chunks = 0